export const SET_COMPANY = 'SET_COMPANY'
export const SET_TERMINALS = 'SET_TERMINALS'
export const SET_VEHICLES = 'SET_VEHICLES'
export const SET_VEHICLE = 'SET_VEHICLE'
export const SET_MEMBER_GROUPS = 'SET_MEMBER_GROUPS'
export const SET_DEV_KEYS = 'SET_DEV_KEYS'
export const SET_ALL_PERMISSIONS = 'SET_ALL_PERMISSIONS'
export const SET_PERMISSIONS_BY_COMPANY = 'SET_PERMISSIONS_BY_COMPANY'
export const SET_REGIONS = 'SET_REGIONS'
export const SET_COMPANY_FEATURES = 'SET_COMPANY_FEATURES'
export const SET_COMMITTED_CONFIG = 'SET_COMMITTED_CONFIG'
export const SET_STRIPE_CUSTOMER = 'SET_STRIPE_CUSTOMER'
export const SET_STRIPE_CUSTOMER_PAYMENTS = 'SET_STRIPE_CUSTOMER_PAYMENTS'
export const SET_COMPANY_LIST = 'SET_COMPANY_LIST'
export const SAVE_MEMBER_ATTRIBURTES = 'SAVE_MEMBER_ATTRIBURTES'



// WEBPACK FOOTER //
// ./src/types/company.js